<epay-page-content [pagetitle]="pagetitle" [usePageContentClasses]="false">
  <div class="page-content-main smi-fullscreen-page" id="page-content-main">
    <div class="smi-iframe-shell">

                <!-- <div id="payment-form"></div> -->

              <div class="loading-indicator loading-indicator--overlay"
                [class.is-visible]="loading && errorMessage === ''"
                [attr.aria-hidden]="!(loading && errorMessage === '')"
                aria-live="polite">
                <div class="spinner-border text-primary" role="status" aria-label="Loading payment form"></div>
                <div class="mt-2">Loading payment form, please wait...</div>
              </div>

              <div *ngIf="!loading && errorMessage !== ''" class="alert alert-danger text-center mb-3" aria-live="assertive">
                <strong>ERROR: {{ errorMessage }}</strong>
                <br>
                <a [routerLink]="['/home']" class="btn btn-primary mt-3">Return to Home</a>
              </div>

              <iframe
                *ngIf="iframeUrl && errorMessage === ''"
                title="SMI Pay Credit Card"
                [src]="urlSafe"
                allow="payment"
                class="smi-hosted-iframe"
                [class.is-ready]="!loading"
                id="hosted-form"
                width="100%"
                height="550"
                (load)="onIframeLoad()"
                (error)="onIframeError()"
                scrolling="auto"
                style="border:none;"
              ></iframe>

        </div>
        </div>
</epay-page-content>
